<template>
  <div class="lg:px-10 px-5 lg:py-10">
    <div class="breadcrumbs">
      <h4>Dashboard > Events</h4>
    </div>
    <div>
      <EventTable />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EventTable from "../components/events/EventTable";
export default {
  name: "Events",
  // head: {
  //   script: [
  //           { src: "https://js.pusher.com/7.0/pusher.min.js", body: true }
  //       ],
  // },
  components: {
    EventTable
  },
  methods: {
    ...mapActions({
      getPredictions: "events/getPredictions"
    })
  },
  created() {
    this.getPredictions();
  }
};
</script>

<style lang="scss" scoped></style>
